import { render, staticRenderFns } from "./ProcessedRepairManage.vue?vue&type=template&id=0ca2c24e&scoped=true"
import script from "./ProcessedRepairManage.vue?vue&type=script&lang=js"
export * from "./ProcessedRepairManage.vue?vue&type=script&lang=js"
import style0 from "./ProcessedRepairManage.vue?vue&type=style&index=0&id=0ca2c24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2c24e",
  null
  
)

export default component.exports